import React from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';

// import Stack from '@material-ui/core/stack';
import Typography from '@material-ui/core/Typography';

export default function CustomSeparator(props) {
  const { parent1, parent2, parent3, parent4 } = props;
  const breadcrumbs = [
    <Typography className="breadcrumbParent" key="1" href="/">
      {parent1}
    </Typography>,
  ];
  if (parent2) {
    breadcrumbs.push(
      <Typography key="2" className="breadcrumbChild">
        {parent2}
      </Typography>
    );
  }
  if (parent3) {
    breadcrumbs.push(
      <Typography key="3" className="breadcrumbChild">
        {parent3}
      </Typography>
    );
  }

  if (parent4) {
    breadcrumbs.push(
      <Typography key="4" className="breadcrumbChild">
        {parent4}
      </Typography>
    );
  }

  return (
    <div spacing={2} className="breadcrumbContainer">
      <Breadcrumbs separator=">" aria-label="breadcrumb">
        {breadcrumbs}
      </Breadcrumbs>
    </div>
  );
}
